import * as React from 'react';
import { Text, UnorderedList, ListItem } from '@chakra-ui/react';

import {
  UploadActions,
  UploadButtonSection,
  UploadComplete as UploadCompleteSection,
  Modal,
  AcknowledgeBox,
  RequirementsSummary
} from 'shared-components';

interface IProps {
  complete: boolean;
  fileNames: string[];
  onContinue: () => void;
  onUpload: () => void;
  onClose: () => void;
  docKey: string;
  infoOnly: boolean;
  docStatus: string;
  onAcknowledgeToggle: (status: string) => void;
}

const PostStudyLetterModal: React.FC<IProps> = (props: IProps) => {
  const { docKey, infoOnly, docStatus } = props;

  const handleOnClose = () => {
    if (docStatus === 'INFO_ONLY') {
      props.onAcknowledgeToggle('NOT_ACKNOWLEDGED');
    }
    props.onClose();
  };

  const toggleAcknowledge = (key: string, value: boolean) => {
    // prevent call to API if previous call not yet complete
    if ((value === true && docStatus !== 'ACKNOWLEDGED') || (value === false && docStatus === 'ACKNOWLEDGED')) {
      props.onAcknowledgeToggle(value === true ? 'ACKNOWLEDGED' : 'NOT_ACKNOWLEDGED');
    }
  };

  return (
    <Modal id={'postStudyLetter'} show={true} title={'Personal Post-Study Letter'} onClose={handleOnClose} hideFooter>
      {props.complete ? (
        <UploadCompleteSection fileNames={props.fileNames} onUpload={props.onUpload} onContinue={props.onContinue} />
      ) : (
        <>
          {infoOnly ? (
            <>
              <Text>
                During your visa application you may be required a personally written letter to explain what you plan to
                do after your overseas study.
              </Text>

              <AcknowledgeBox
                id={docKey}
                blurb="Please confirm you have read and understand the above."
                isTicked={docStatus === 'ACKNOWLEDGED'}
                onChange={toggleAcknowledge}
              />

              <UploadActions
                complete={docStatus === 'ACKNOWLEDGED'}
                onContinue={handleOnClose}
                label="Return to document upload"
              />
            </>
          ) : (
            <>
              <Text>
                We require a personally written letter to explain what you plan to do after your overseas study.
              </Text>

              <RequirementsSummary title="Please write a letter that covers the following requirements:">
                <UnorderedList>
                  <ListItem>Where you plan to live</ListItem>
                  <ListItem>How your new qualification will factor into your career, work or vacation</ListItem>
                  <ListItem>Where you would like to be in 5 years time</ListItem>
                  <ListItem>Your signature on the letter</ListItem>
                </UnorderedList>
              </RequirementsSummary>

              <UploadButtonSection onUpload={props.onUpload}>
                Awaiting upload of <b>Personal Post-Study Letter</b>
              </UploadButtonSection>

              <UploadActions complete={props.complete} onContinue={props.onContinue} />
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default PostStudyLetterModal;
